var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
/* eslint-disable prettier/prettier */
// 人员选择器左侧组件
import React, { useState, useRef, useEffect } from 'react';
import { List, message, Empty } from 'antd';
import { SearchType, SelectorMode, UserSelTab, } from './types';
import UserSelectionContext from './context';
import TabPaneListItem from './tabs/TabPaneListItem';
// import SearchContract from './search';
import SearchInput from './search/Input';
import SelectionTabs from './tabs';
import { mapSearchContacts, mapSearchCustomMember, selectContactTypeListItem, } from './common';
import { uniqBy, debounce, trim as lodashTrim } from 'lodash';
import { useLoadingProps } from './hooks';
import GlobalSearchModal from './GlobalSearch';
import InputAreaContext from '../UserSelectionModal/context';
export function LeftSideFixedUsers(_a) {
    var result = _a.result, onItemCheck = _a.onItemCheck, onSearchGlobal = _a.onSearchGlobal;
    var _b = React.useContext(UserSelectionContext), fIds = _b.frozenIds, t = _b.t, dataListFilter = _b.dataListFilter, _c = _b.searchPlaceHolder, searchPlaceHolder = _c === void 0 ? '' : _c, single = _b.single, data = _b.fixedUsers, currentUser = _b.currentUser, contactShowType = _b.contactShowType, 
    // mode,
    tabs = _b.tabs;
    var _d = React.useContext(InputAreaContext), setNewMode = _d.setNewMode, newMode = _d.newMode;
    var _e = useState(data), fixedData = _e[0], setFixedData = _e[1];
    var _f = useState(''), searchValue = _f[0], setSearchValue = _f[1];
    var canSearch = React.useMemo(function () {
        return newMode !== SelectorMode.transfer;
    }, [newMode]);
    function doSearch(value) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, contacts, sessions, contactsData, result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!value) {
                            setFixedData([]);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, onSearchGlobal({
                                keyword: value,
                                searchType: SearchType.Contacts,
                                pageNo: 1,
                                pageSize: 10,
                                // needSession: true,
                                needSession: false,
                            })];
                    case 1:
                        _a = _b.sent(), contacts = _a.contacts, sessions = _a.sessions;
                        contactsData = [];
                        if (contactShowType) {
                            contactsData = selectContactTypeListItem(contactShowType, mapSearchContacts(contacts), currentUser);
                            // contactsData = contactsListData(contactsFilterFlag,  mapSearchContacts(contacts), currentUser)
                        }
                        else {
                            contactsData = mapSearchContacts(contacts);
                        }
                        result = uniqBy(__spreadArrays((sessions || []), (contactsData || [])), 'id');
                        if (dataListFilter) {
                            result = result.filter(dataListFilter);
                        }
                        // console.log('onSearchGlobal ==>', result);
                        setFixedData(result || []);
                        return [2 /*return*/];
                }
            });
        });
    }
    var doSearchDebounce = useRef(debounce(doSearch, 500)).current;
    useEffect(function () {
        if (!lodashTrim(searchValue)) {
            setFixedData(data);
            return;
        }
        setFixedData(null);
        doSearchDebounce(searchValue);
    }, [searchValue, doSearchDebounce, data]);
    var loadingProps = useLoadingProps(fixedData);
    var getFreeze = React.useCallback(function (id) {
        return fIds.findIndex(function (a) { return a === id; }) >= 0;
    }, [fIds]);
    var getChecked = React.useCallback(function (freeze, id) {
        return freeze || result.findIndex(function (b) { return b.id === id; }) >= 0;
    }, [result]);
    return (React.createElement("div", { className: "userSelectionModalLeft" },
        canSearch && (React.createElement(SearchInput, { placeholder: searchPlaceHolder || t('userSelection.session_contacts'), searchValue: searchValue, onSearchValueChange: function (val) {
                setSearchValue(val);
            } })),
        React.createElement("div", { className: "userSelectionWrap", style: { paddingTop: '10px' } }, (fixedData || []).length === 0 ? (React.createElement(Empty, { image: Empty.PRESENTED_IMAGE_SIMPLE, description: "\u6682\u65E0\u6570\u636E" })) : (React.createElement(List, { loading: loadingProps, dataSource: fixedData || [], renderItem: function (item) {
                var id = item.id;
                var freeze = getFreeze(id);
                var checked = getChecked(freeze, id);
                return (React.createElement(TabPaneListItem, { disabled: freeze, data: __assign(__assign({}, item), { checked: checked }), single: single, checkable: true, onCheckChange: function (a) {
                        if (checked) {
                            onItemCheck(a);
                        }
                        else {
                            if (result.length === 20) {
                                message.warn('达到最大选择人数');
                                return false;
                            }
                            onItemCheck(a);
                        }
                    } }));
            } })))));
}
export function LeftSideStrangerUsersRosters(_a) {
    var result = _a.result, strangerResult = _a.strangerResult, onItemCheck = _a.onItemCheck, onSearchStranger = _a.onSearchStranger, getSearchExtraPart = _a.getSearchExtraPart;
    var _b = React.useContext(UserSelectionContext), fIds = _b.frozenIds, t = _b.t, single = _b.single, currentUser = _b.currentUser, contactShowType = _b.contactShowType, 
    // mode,
    tabs = _b.tabs, searchValue = _b.searchValue, setSearchValue = _b.setSearchValue;
    var _c = React.useContext(InputAreaContext), setNewMode = _c.setNewMode, newMode = _c.newMode;
    var _d = useState([]), fixedData = _d[0], setFixedData = _d[1];
    function doSearch(value) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, contactList, total, res;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!value) {
                            setFixedData([]);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, onSearchStranger({ keyword: value })];
                    case 1:
                        _a = _b.sent(), contactList = _a.contactList, total = _a.total;
                        res = contactList && contactList.length > 0 ? mapSearchCustomMember(contactList) : [];
                        console.log('onSearchStranger ==>', contactList, res);
                        setFixedData(res || []);
                        return [2 /*return*/];
                }
            });
        });
    }
    var doSearchDebounce = useRef(debounce(doSearch, 500)).current;
    useEffect(function () {
        if (!lodashTrim(searchValue)) {
            setFixedData([]);
            return;
        }
        setFixedData(null);
        doSearchDebounce(searchValue);
    }, [searchValue, doSearchDebounce]);
    var loadingProps = useLoadingProps(fixedData);
    var getFreeze = React.useCallback(function (id) {
        return fIds.findIndex(function (a) { return a === id; }) >= 0;
    }, [fIds]);
    var getChecked = React.useCallback(function (freeze, id) {
        return freeze || __spreadArrays(result, strangerResult).findIndex(function (b) { return b.id === id; }) >= 0;
    }, [result, strangerResult]);
    return (React.createElement("div", { className: "userSelectionModalLeft" },
        React.createElement(SearchInput, { placeholder: "\u641C\u7D22\u975E\u8054\u7CFB\u4EBA", searchValue: searchValue, onSearchValueChange: function (val) {
                setSearchValue(val);
            } }),
        React.createElement("div", { className: "userSelectionWrap", style: { paddingTop: '10px' } }, (fixedData || []).length === 0 ? (React.createElement(Empty, { image: Empty.PRESENTED_IMAGE_SIMPLE, description: "\u6682\u65E0\u6570\u636E" })) : (React.createElement(List, { loading: loadingProps, dataSource: fixedData || [], renderItem: function (item) {
                var id = item.id;
                var freeze = getFreeze(id);
                var checked = getChecked(freeze, id);
                return (React.createElement(TabPaneListItem, { disabled: freeze, data: __assign(__assign({}, item), { checked: checked }), checkable: true, onCheckChange: function () {
                        onItemCheck(__assign(__assign({}, item), { checked: checked }));
                    }, extra: getSearchExtraPart === null || getSearchExtraPart === void 0 ? void 0 : getSearchExtraPart(item) }));
            } })))));
}
export function LeftSideFixedUsersRosters(_a) {
    var result = _a.result, onItemCheck = _a.onItemCheck, onSearchGroupMember = _a.onSearchGroupMember;
    var _b = React.useContext(UserSelectionContext), fIds = _b.frozenIds, t = _b.t, searchPlaceHolder = _b.searchPlaceHolder, single = _b.single, data = _b.fixedUsers, currentUser = _b.currentUser, dataListFilter = _b.dataListFilter, contactShowType = _b.contactShowType;
    var _c = useState(data), fixedData = _c[0], setFixedData = _c[1];
    var _d = useState(''), searchValue = _d[0], setSearchValue = _d[1];
    function doSearch(value) {
        return __awaiter(this, void 0, void 0, function () {
            var contactsData, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        contactsData = data;
                        if (contactShowType) {
                            contactsData = selectContactTypeListItem(contactShowType, data, currentUser);
                            // contactsData = contactsListData(contactsFilterFlag,  data, currentUser)
                            setFixedData(contactsData);
                        }
                        // console.log('contactsData ==>', contactsData);
                        if (!value) {
                            setFixedData(contactsData);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, onSearchGroupMember(value, contactsData)];
                    case 1:
                        result = _a.sent();
                        if (dataListFilter) {
                            result = result.filter(dataListFilter);
                        }
                        // console.log('onSearchGroupMember ==>', value, result);
                        setFixedData(result || []);
                        return [2 /*return*/];
                }
            });
        });
    }
    var doSearchDebounce = useRef(debounce(doSearch, 500)).current;
    useEffect(function () {
        // if (!searchValue) {
        //     console.log(66666, data);
        //     setFixedData(data);
        //     return;
        // }
        setFixedData(null);
        doSearchDebounce(searchValue);
    }, [searchValue, doSearchDebounce, data]);
    var loadingProps = useLoadingProps(fixedData);
    var getFreeze = React.useCallback(function (id) {
        return fIds.findIndex(function (a) { return a === id; }) >= 0;
    }, [fIds]);
    var getChecked = React.useCallback(function (freeze, id) {
        return freeze || result.findIndex(function (b) { return b.id === id; }) >= 0;
    }, [result]);
    return (React.createElement("div", { className: "userSelectionModalLeft" },
        React.createElement(SearchInput, { placeholder: searchPlaceHolder || t('userSelection.session_contacts'), searchValue: searchValue, onSearchValueChange: function (val) {
                setSearchValue(val);
            } }),
        React.createElement("div", { className: "userSelectionWrap", style: { paddingTop: '10px' } }, (fixedData || []).length === 0 ? (React.createElement(Empty, { image: Empty.PRESENTED_IMAGE_SIMPLE, description: "\u6682\u65E0\u6570\u636E" })) : (React.createElement(List, { loading: loadingProps, dataSource: fixedData || [], renderItem: function (item) {
                var id = item.id;
                var freeze = getFreeze(id);
                var checked = getChecked(freeze, id);
                return (React.createElement(TabPaneListItem, { disabled: freeze, data: __assign(__assign({}, item), { checked: checked }), single: single, checkable: true, onCheckChange: function (a) {
                        if (checked) {
                            onItemCheck(a);
                        }
                        else {
                            if (result.length === 20) {
                                message.warn('达到最大选择人数');
                                return false;
                            }
                            onItemCheck(a);
                        }
                    } }));
            } })))));
}
export default function LeftSide(props) {
    var _a = React.useContext(UserSelectionContext), t = _a.t, tabs = _a.tabs, searchValue = _a.searchValue, setSearchValue = _a.setSearchValue;
    var result = props.result, onItemCheck = props.onItemCheck, onSearchGlobal = props.onSearchGlobal, onSearchStranger = props.onSearchStranger, onGetEBookDeptInfo = props.onGetEBookDeptInfo, onGetEBookWorkLineInfo = props.onGetEBookWorkLineInfo, onGetEBookOrgInfo = props.onGetEBookOrgInfo, onGetRecentData = props.onGetRecentData, onGetAgentForData = props.onGetAgentForData, onGetTopData = props.onGetTopData, onGetExternalContacts = props.onGetExternalContacts, onGetGroupData = props.onGetGroupData, onGetGroupMembersData = props.onGetGroupMembersData, onGetTagData = props.onGetTagData, onGetTagMembersData = props.onGetTagMembersData, onGetBusinessData = props.onGetBusinessData, onGetRecommendInfo = props.onGetRecommendInfo, onGetRecentIncludeGroup = props.onGetRecentIncludeGroup, getSearchExtraPart = props.getSearchExtraPart, onSearchGroupMember = props.onSearchGroupMember, onAnalysisLog = props.onAnalysisLog, onInputStrangerLeaveWordChange = props.onInputStrangerLeaveWordChange;
    // 如果传了获取用户的simpleDeptInfoList  tab项展示用户所在最近的部门名称
    // 没有传获取用户组织架构的方法， tab项显示`组织架构`字样
    // const [searchValue, setSearchValue] = useState('');
    var _b = useState(), defaultTabActiveKey = _b[0], setDefaultTabActiveKey = _b[1];
    var _c = useState(null), jumpCurrentGroupItem = _c[0], setJumpCurrentGroupItem = _c[1];
    var _d = useState(null), jumpCurrentOrgItem = _d[0], setJumpCurrentOrgItem = _d[1];
    return (React.createElement("div", { className: "userSelectionModalLeft" },
        !tabs.includes('agentFor') && (React.createElement(GlobalSearchModal, { result: result, onItemCheck: onItemCheck, onSearchGlobal: onSearchGlobal, jumpCurrentTabsGroup: function (item) {
                setDefaultTabActiveKey(UserSelTab.group);
                setJumpCurrentGroupItem(item);
            }, jumpCurrentTabsOrg: function (item) {
                setDefaultTabActiveKey(item.isWorkLine ? UserSelTab.workLine : UserSelTab.org);
                setJumpCurrentOrgItem(item);
            }, handleSetSearchValue: function (val) {
                setSearchValue(val);
            }, searchValue: searchValue, getSearchExtraPart: getSearchExtraPart, onSearchGroupMember: onSearchGroupMember, onAnalysisLog: onAnalysisLog, onInputStrangerLeaveWordChange: onInputStrangerLeaveWordChange })),
        React.createElement(SelectionTabs, { defaultTabActiveKey: defaultTabActiveKey, jumpCurrentGroupItem: jumpCurrentGroupItem, jumpCurrentOrgItem: jumpCurrentOrgItem, clearJumpCurrentGroup: function () {
                setDefaultTabActiveKey('');
                setJumpCurrentGroupItem(null);
            }, clearJumpCurrentOrg: function () {
                setDefaultTabActiveKey('');
                setJumpCurrentOrgItem(null);
            }, onAnalysisLog: onAnalysisLog, result: result, onItemCheck: onItemCheck, onGetEBookDeptInfo: onGetEBookDeptInfo, onGetEBookWorkLineInfo: onGetEBookWorkLineInfo, onGetEBookOrgInfo: onGetEBookOrgInfo, onGetRecentData: onGetRecentData, onGetRecentIncludeGroup: onGetRecentIncludeGroup, onGetAgentForData: onGetAgentForData, onGetTopData: onGetTopData, onGetExternalContacts: onGetExternalContacts, onGetGroupData: onGetGroupData, onGetTagData: onGetTagData, onGetTagMembersData: onGetTagMembersData, onGetGroupMembersData: onGetGroupMembersData, onGetBusinessData: onGetBusinessData, onGetRecommendInfo: onGetRecommendInfo })));
}
//# sourceMappingURL=LeftSide.js.map